import type { IntlShape } from 'react-intl';

import { getLinkAriaLabel } from '@/utils/urlUtils';

import { WATCH_SKU_REGEX } from '@/integrations/algolia/helpers';
import { commonMessages } from '@/messages/common';

export const getMediaWrapperAriaLabel = (
  url: string | null | undefined,
  imageTitle: string | null | undefined,
  formatMessage: IntlShape['formatMessage'],
  languageCode: string,
) => {
  const label = getLinkAriaLabel(url ?? '', languageCode);
  if (label) return label;

  if (url) {
    const path = url.split('?')[0].replace(/\/$/, '');
    const segments = path.split('/');
    const lastSegment = segments[segments.length - 1];

    // SKU is usually uppercase alphanumeric
    if (lastSegment && WATCH_SKU_REGEX.test(lastSegment)) {
      return `${formatMessage(commonMessages.discover)} ${imageTitle ?? ''}`;
    }
  }

  return undefined;
};
